import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/header-1403.png'
import _imports_1 from '@/assets/header-1404.png'
import _imports_2 from '@/assets/header-1402.png'
import _imports_3 from '@/assets/Expocosmetica26.png'
import _imports_4 from '@/assets/header-2837.png'
import _imports_5 from '@/assets/header-3025.png'
import _imports_6 from '@/assets/header-3154.png'


const _hoisted_1 = {
  key: 0,
  class: "ticket-header"
}
const _hoisted_2 = ["alt"]
const _hoisted_3 = {
  key: 1,
  class: "ticket-header"
}
const _hoisted_4 = ["alt"]
const _hoisted_5 = {
  key: 2,
  class: "ticket-header"
}
const _hoisted_6 = ["alt"]
const _hoisted_7 = {
  key: 3,
  class: "ticket-header"
}
const _hoisted_8 = ["alt"]
const _hoisted_9 = {
  key: 4,
  class: "ticket-header"
}
const _hoisted_10 = ["alt"]
const _hoisted_11 = {
  key: 5,
  class: "ticket-header"
}
const _hoisted_12 = ["alt"]
const _hoisted_13 = {
  key: 6,
  class: "ticket-header"
}
const _hoisted_14 = ["alt"]
const _hoisted_15 = { class: "ticket-container" }
const _hoisted_16 = {
  key: 0,
  class: "lds-default"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_29 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "qrcode-ticket-title"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "ticket-type-name"
}
const _hoisted_33 = {
  key: 2,
  class: "event-name"
}
const _hoisted_34 = {
  key: 3,
  class: "code-link"
}
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 1,
  "ng-if": "!controller.loading && !controller.ticket_type",
  style: {"margin-top":"55px"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-symbols-outlined",
  style: {"font-size":"72px","margin-bottom":"30px"}
}, " block ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h5", null, "Ticket code is invalid.", -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]

import router from "@/router";
import { ticketQrcodeCheck } from "@/api/tickets";
import { ITicket } from "@/models/ticket";
import { ref } from "vue";
import QRCodeVue3 from "qrcode-vue3";
import "@fontsource/roboto";
import moment from "moment";
import { beamianLogo, vodafoneLogo, ps_logo } from "@/utils/logos";
import EuropeanRocketry25 from "@/assets/EuropeanRocketry25.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const ticketCode = router.currentRoute.value.params.ticket_code as string;
const ticket = ref({} as ITicket);
const loading = ref(true as boolean);
const image = ref(beamianLogo);

const vodafoneEventNames = [
  "PRIMAVERA SOUND PORTO 2024",
  "Primavera Sound Porto 2025",
  "PRIMAVERA SOUND PORTO 2026",
  "Reunião Vodafone 2024",
  "VODAFONE PAREDES DE COURA 2024",
  "Reunião Anual Vodafone 2025",
  "VODAFONE PAREDES DE COURA 2025",
  "VODAFONE PAREDES DE COURA 2026",
];

const formatDate = (value: string): string => {
  if (value) {
    return moment(String(value)).format("DD/MM h:mm a");
  }
  return value;
};

ticketQrcodeCheck(ticketCode)
  .then((response) => {
    loading.value = false;
    ticket.value = response.data;
    console.log(ticket.value)
    // Case for PRIMAVERA SOUND PORTO 2024
    if (vodafoneEventNames.includes(ticket.value.event_name)) {
      image.value = vodafoneLogo;
    }

    // Case for Centenário de Mário Soares event (2771)
    if(ticket.value.event_name === 'Centenário de Mário Soares') {
      image.value = ps_logo;
    }

    if(ticket.value.event_name === 'European Rocketry Challenge 25') {
      image.value = EuropeanRocketry25;
    }
  })
  .catch(() => {
    loading.value = false;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (
        ['Guilty Masters by In Beauty Academy 2024'].includes(ticket.value.event_name)
      )
      ? (_openBlock(), _createElementBlock("figure", _hoisted_1, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ticket.value.event_name
          }, null, 8, _hoisted_2)
        ]))
      : (
        ['Formação de Estética by In Beauty Academy 2024'].includes(
          ticket.value.event_name
        )
      )
        ? (_openBlock(), _createElementBlock("figure", _hoisted_3, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ticket.value.event_name
            }, null, 8, _hoisted_4)
          ]))
        : (
        ['Formação de Cabelo by In Beauty Academy 2024'].includes(
          ticket.value.event_name
        )
      )
          ? (_openBlock(), _createElementBlock("figure", _hoisted_5, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: ticket.value.event_name
              }, null, 8, _hoisted_6)
            ]))
          : (
        ['Lash Secrets Conference', 'Meeting Científico Multidisciplinar em Estética'].includes(ticket.value.event_name)
      )
            ? (_openBlock(), _createElementBlock("figure", _hoisted_7, [
                _createElementVNode("img", {
                  src: _imports_3,
                  alt: ticket.value.event_name
                }, null, 8, _hoisted_8)
              ]))
            : (
        ['INTERNATIONAL HAIR SHOW by Expocosmética & Academy in Motion 2025'].includes(
          ticket.value.event_name
        )
      )
              ? (_openBlock(), _createElementBlock("figure", _hoisted_9, [
                  _createElementVNode("img", {
                    src: _imports_4,
                    alt: ticket.value.event_name
                  }, null, 8, _hoisted_10)
                ]))
              : _createCommentVNode("", true),
    (
        ['Guilty Masters by Expocosmética 2025'].includes(ticket.value.event_name)
      )
      ? (_openBlock(), _createElementBlock("figure", _hoisted_11, [
          _createElementVNode("img", {
            src: _imports_5,
            alt: ticket.value.event_name
          }, null, 8, _hoisted_12)
        ]))
      : _createCommentVNode("", true),
    (
        ['Beauty School by Expocosmética 2025'].includes(ticket.value.event_name)
      )
      ? (_openBlock(), _createElementBlock("figure", _hoisted_13, [
          _createElementVNode("img", {
            src: _imports_6,
            alt: ticket.value.event_name
          }, null, 8, _hoisted_14)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_29))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (!loading.value)
          ? (_openBlock(), _createBlock(_unref(QRCodeVue3), {
              width: 256,
              height: 256,
              value: ticket.value.ticket_code,
              key: ticket.value.ticket_code,
              dotsOptions: {
            type: 'squares',
          },
              margin: 20,
              cornersSquareOptions: { type: 'square' },
              cornersDotOptions: { type: 'square' },
              "qr-options": {
            errorCorrectionLevel: 'H',
          },
              imageOptions: {
            margin: 4,
          },
              image: image.value,
              imgclass: "qr-code-container"
            }, null, 8, ["value", "image"]))
          : _createCommentVNode("", true),
        (!loading.value && ticket.value.ticket_code)
          ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
              (ticket.value.event_name == 'Reunião Vodafone 2024')
                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Apresente este QR code nos pontos de credenciação. Este código é individual e intransmissível."))
                : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(ticket.value.ticket_type_name), 1))
            ]))
          : _createCommentVNode("", true),
        (!loading.value && ticket.value.ticket_code)
          ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(ticket.value.event_name), 1))
          : _createCommentVNode("", true),
        (!loading.value && ticket.value.ticket_code)
          ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
              _createElementVNode("span", null, [
                _createElementVNode("a", {
                  href: `https://ticket.beamian.com/${ticket.value.ticket_code}`,
                  target: "_blank"
                }, "ticket.beamian.com/" + _toDisplayString(ticket.value.ticket_code), 9, _hoisted_35)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (!loading.value && !ticket.value.ticket_code)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_39))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})